export default function BrandMark() {
  return (
    <div className="flex flex-col items-center" style={{ animationDelay: '0ms' }}>
      <h1
        className="text-2xl font-bold tracking-[0.3em] text-[#1F2024]"
        style={{ fontFamily: 'Pretendard, system-ui, sans-serif' }}
      >
        ACCU-Z
      </h1>
      <p
        className="text-[11px] tracking-[0.35em] text-[#55575D] mt-1"
        style={{ fontFamily: 'Pretendard, system-ui, sans-serif' }}
      >
        BEAUTY CARE
      </p>
    </div>
  );
}